export const getOrders = `query Orders($page:Int){
    allOrders(page:$page){
      _id
      deliveryAddress
      deliveryCharges
      orderAmount
      paidAmount
      paymentMethod
      orderId
      user{
        _id
        name
        email
        phone
      }
      items{
        _id
        food{
          _id
          title
          description
          image
        }
        variation{
          _id
          title
          price
          discounted
        }
        addons{
          _id
          title
          description
          quantityMinimum
          quantityMaximum
          options{
            _id
            title
            price
          }
        }
        specialInstructions
        quantity
      }
      reason
      status
      paymentStatus
      orderStatus
      createdAt
      review{
        _id
        rating
        description
      }
      rider{
        _id
        name
      }
    }
  }`

export const getAllOrdersForSuperAdmin = `query AllOrdersPaginated($page: Int, $rows: Int, $search: String, $startDate: String, $endDate: String, $sortBy: String) {
    allOrdersPaginated(page: $page, rows: $rows, search: $search, startDate: $startDate, endDate: $endDate, sortBy: $sortBy) {
      orders {
        _id
        orderId
        createdAt
        restaurant {
          _id
          name
        }
        deliveryAddress {
          deliveryAddress
        }
        user {
          _id
          name
          phone
        }
        items {
          _id
        }
        orderDate
        orderStatus
        paymentMethod
        coupon {
          _id
          title
          discount
          discountType
        }
      }
      nextPage
      prevPage
      totalCount
      totalPages
      currentPage
    }
  }`

export const getCourierOrders = `query CourierOrdersPaginated($page: Int, $rows: Int, $search: String, $startDate: String, $endDate: String, $courierStatus: String) {
    courierOrdersPaginated(page: $page, rows: $rows, search: $search, startDate: $startDate, endDate: $endDate, courierStatus: $courierStatus) {
      orders {
        _id
        orderId
        createdAt
        orderStatus
        orderAmount
        paymentMethod
        deliveryMode
        courierStatus
        courierName
        courierTrackingNumber
        courierEstimatedDelivery
        courierUpdatedAt
        deliveryCountry
        rider {
          _id
          name
        }
        deliveryAddress {
          deliveryAddress
          details
        }
        user {
          _id
          name
          phone
        }
        restaurant {
          _id
          name
          address
        }
        items {
          _id
          title
          quantity
        }
      }
      nextPage
      prevPage
      totalCount
      totalPages
      currentPage
    }
  }`

export const getSuperAdminOrderDetail = `query Order($id: String!) {
    order(id: $id) {
      _id
      orderId
      orderStatus
      createdAt
      isPickedUp
      reason
      deliveryAddress {
        deliveryAddress
        details
        label
      }
      restaurant {
        _id
        name
        address
      }
      rider {
        _id
        name
      }
      items {
        _id
        description
        image
        quantity
        specialInstructions
        title
        variation {
          price
          title
        }
        addons {
          title
          options {
            title
            price
          }
        }
      }
      orderAmount
      paidAmount
      paymentMethod
      deliveryCharges
      taxationAmount
      tipping
      user {
        _id
        name
        phone
        email
      }
    }
  }`

export const reviews = `query Reviews($restaurant:String!){
    reviews(restaurant:$restaurant){
      _id
      isAnonymous
      reviewerName
      reviewerEmail
      order{
        _id
        orderId
        items{
          title
        }
        user{
          _id
          name
          email
        }
      }
      restaurant{
        _id
        name
        image
      }
      rating
      description
      createdAt
    }
  }
`

export const getOrdersByDateRange = `query GetOrdersByDateRange($startingDate: String!, $endingDate: String!, $restaurant: String!) {
    getOrdersByDateRange(startingDate: $startingDate, endingDate: $endingDate, restaurant: $restaurant) {
      totalAmountCashOnDelivery
      countCashOnDeliveryOrders
    }
    
  }
`

export const getOrdersByRestaurant = `query ordersByRestId($restaurant:String!,$page:Int,$rows:Int,$search:String){
    ordersByRestId(restaurant:$restaurant,page:$page,rows:$rows,search:$search){
      _id
      orderId
      restaurant{
        _id
        name
        image
        address
        location{coordinates}
      }
      deliveryAddress{
        location{coordinates}
        deliveryAddress
        details
        label
      }
      items{
        _id
        title
        description
        image
        quantity
        variation{
          _id
          title
          price
          discounted
        }
        addons{
          _id
          options{
            _id
            title
            description
            price
          }
          description
          title
          quantityMinimum
          quantityMaximum
        }
        specialInstructions
        isActive
        createdAt
        updatedAt
      }
      user{
        _id
        name
        phone
        email
      }
      paymentMethod
      paidAmount
      orderAmount
      orderStatus
      isPickedUp
      status
      paymentStatus
      reason
      isActive
      createdAt
      deliveryCharges
      tipping
      taxationAmount
      coupon{
        _id
        title
        discount
        discountType
      }
      rider{
        _id
        name
        username
        available
      }
    }
  }`

export const getDashboardTotal = `query GetDashboardTotal($startingDate: String, $endingDate: String,$restaurant:String!){
    getDashboardTotal(starting_date: $startingDate, ending_date: $endingDate,restaurant:$restaurant){
      totalOrders
      totalSales
    }
  }`
export const getDashboardSales = `query GetDashboardSales($startingDate: String, $endingDate: String,$restaurant:String!){
    getDashboardSales(starting_date: $startingDate, ending_date: $endingDate,restaurant:$restaurant){
      orders{
        day
        amount
      }
    }
  }`
export const getDashboardOrders = `query GetDashboardOrders($startingDate: String, $endingDate: String,$restaurant:String!){
    getDashboardOrders(starting_date: $startingDate, ending_date: $endingDate,restaurant:$restaurant){
      orders{
        day
        count
      }
    }
  }`

export const getDashboardData = `query GetDashboardData($startingDate: String, $endingDate: String){
    getDashboardData(starting_date: $startingDate, ending_date: $endingDate){
      totalOrders
      totalUsers
      totalSales
      orders{
        day
        count
        amount
      }
    }
  }`

export const getConfiguration = `query GetConfiguration{
    configuration{
      _id
      email
      emailName
      password
      enableEmail
      clientId
      clientSecret
      sandbox
      publishableKey
      secretKey
      currency
      currencySymbol
      deliveryRate
      twilioAccountSid
      twilioAuthToken
      twilioPhoneNumber
      twilioEnabled
      formEmail
      sendGridApiKey
      sendGridEnabled   
      sendGridEmail
      sendGridEmailName
      sendGridPassword
      dashboardSentryUrl
      webSentryUrl
      apiSentryUrl
      customerAppSentryUrl
      restaurantAppSentryUrl
      riderAppSentryUrl
      googleApiKey
      cloudinaryUploadUrl
      cloudinaryApiKey
      webAmplitudeApiKey
      appAmplitudeApiKey
      webClientID
      androidClientID
      iOSClientID
      expoClientID
     
      googleMapLibraries
      googleColor    
      termsAndConditions
      privacyPolicy
      testOtp
      firebaseKey
      authDomain
      projectId
      storageBucket
      msgSenderId
      appId
      measurementId
      isPaidVersion
      skipEmailVerification
      skipMobileVerification
      costType
      flatDeliveryFee
      flatDeliveryLimit
      platformFeesValue
      supportChatNumber
      referralEnabled
      referralCredits
      loyaltyEnabled
      loyaltyTiers {
        minOrderAmount
        credits
      }
      creditsPerPound
      companyName
      companyAddress
      companyPhone
      companyFax
      vatNumber
      messageoftheDay
    }
  }`

export const getMessageOfTheDay = `query GetMessageOfTheDay($restaurantId:String!){
  getMessageOfTheDay(restaurantId:$restaurantId)
}`

export const orderCount = `
query OrderCount($restaurant:String!,$search:String){
  orderCount(restaurant:$restaurant,search:$search)
}`

export const getActiveOrders = `query GetActiveOrders($restaurantId:ID){
  getActiveOrders(restaurantId:$restaurantId){
    _id
    zone{
      _id
    }
    deliveryMode
    courierStatus
    orderId
    restaurant{
      _id
      name
      image
      address
      location{coordinates}
    }
    deliveryAddress{
      location{coordinates}
      deliveryAddress
      details
      label
    }
    items{
      _id
      title
      description
      image
      quantity
      variation{
        _id
        title
        price
        discounted
      }
      addons{
        _id
        options{
          _id
          title
          description
          price
        }
        description
        title
        quantityMinimum
        quantityMaximum
      }
      specialInstructions
      isActive
      createdAt
      updatedAt
    }
    user{
      _id
      name
      phone
      email
    }
    paymentMethod
    paidAmount
    orderAmount
    orderStatus
    isPickedUp
    preparationTime
    acceptedAt
    orderNotes
    riderNotes
    deliveryNotes
    instructions
    status
    paymentStatus
    reason
    isActive
    createdAt
    deliveryCharges
    rider{
      _id
      name
      username
      available
    }
  }
}`

export const getRidersByZone = `query RidersByZone($id:String!){
  ridersByZone(id:$id){
    _id
    name
    username
    password
    phone
    available
    zone{
      _id
      title
    }
  }
}`

export const getZones = `query Zones{
    zones{
    _id
    title
    description
    location{coordinates}
    isActive
    riderFee
    country
    }
}`

export const getCountriesList = `query GetCountries{
    getCountries{
      id
      name
      iso2
    }
}`

export const getZoneSpotlights = `query ZoneSpotlights{
    zoneSpotlights{
      _id
      shopType
      title
      restaurants
      isActive
      zone{
        _id
        title
      }
    }
}`

export const getZoneCurrentRestaurants = `query ZoneCurrentRestaurants($zone:String!,$shopType:String){
    zoneCurrentRestaurants(zone:$zone,shopType:$shopType){
      _id
      name
      image
      shopType
      isActive
    }
}`

export const getVendors = `query Vendors{
    vendors{
      _id
      email
      userType
      restaurants{
        _id
        orderId
        orderPrefix
        slug
        name
        image
        address
        location{coordinates}
        zone{
          _id
          title
        }
        shopType
      }
    }
}`

export const getVendor = `query GetVendor($id:String!){
    getVendor(id:$id){
        _id
        email
        userType
        restaurants{
          _id
          orderId
          orderPrefix
          slug
          name
          image
          address
          location{coordinates}
          shopType
        }
    }
}`

export const getTaxation = `query Taxes{
    taxes {
      _id
      taxationCharges
      enabled
      }
    }`

export const getCoupons = `query Coupons{
    coupons {
      _id
      title
      discount
      enabled
      discountType
      maxCouponLimit
      customerUsageLimit
      appliesTo
    }
  }`

export const getFreeDelivery = `query GetFreeDelivery($restaurantId: String!){
    getFreeDelivery(restaurantId: $restaurantId) {
      minimumOrder
      freeDeliveryLimit
      distanceLimit
      isEnabled
      voucherEnabled
      couponCode
      farDistance
      farDistanceFee
      farDistanceNotice
      farDistanceEnabled
    }
  }`

export const getCuisines = `query Cuisines{
    cuisines {
      _id
      name
      description
      image
      emoji
      order
      shopType
    }
  }`

export const getShopTypes = `query ShopTypes{
    shopTypes {
      _id
      title
      slug
      description
      image
      emoji
      order
      isActive
      displayVariant
    }
  }`

// Only the shop types the admin has enabled - what the customer app shows as
// tiles, and what a store can be filed under from its profile
export const getActiveShopTypes = `query ActiveShopTypes{
    activeShopTypes {
      _id
      title
      slug
      order
    }
  }`

export const getTipping = `query Tips{
    tips {
      _id
      tipVariations
      enabled
    }
  }`

export const getAddons = `query Addons{
    addons{
    _id
    title
    description
    options{
      _id
      title
      description
      price
    }
    quantityMinimum
    quantityMaximum
  }}`

export const getOptions = `query Options{
    options {
      _id
      title
      description
      price
    }
  }
  `
export const getPaymentStatuses = `query{
    getPaymentStatuses
  }`

export const restaurantByOwner = `query RestaurantByOwner($id:String){
  restaurantByOwner(id:$id){
  _id
  email
  userType
  restaurants{
    _id
    orderId
    orderPrefix
    name
    slug
    image
    address
    username
    password
    phone
    webURL
    bagFee
    location{coordinates}
    shopType
    }
  }
}`

export const restaurantList = `query RestaurantList{
  restaurantList{
    _id
    name
    address
    image
  }
}`

export const restaurants = `query Restaurants{
  restaurants{
    _id
    name
    image
    orderPrefix
    slug
    address
    deliveryTime
    minimumOrder
    isActive
    isAvailable
    commissionRate
    tax
    owner{
      _id
      email
    }
    shopType
  }
}
`

export const getRestaurantProfile = `query Restaurant($id:String){
      restaurant(id:$id)
      {
      _id
      orderId
      orderPrefix
      slug
      name
      image
      address
      categoryType
      location{coordinates}
      deliveryBounds{
        coordinates
      }
      username
      password
      deliveryTime
      deliveryType
      deliveryDays
      countryWideDelivery
      courierDeliveryTime
      courierDeliveryUnit
      country
      minimumOrder
      tax
      serviceFeeType
      serviceFeeMin
      serviceFeeMax
      phone
      webURL
      bagFee
      isAvailable
      stripeDetailsSubmitted
      openingTimes{
        day
        times{
          startTime
          endTime
        }
      }
      owner{
        _id
        email
      }
      shopType
      displayVariant
      tagline
      promoMessages
      promoEnabled
      comingSoon
      cuisines
      restDeliveryRate
      hygieneRating
      allowKlarna
      clearPayEnabled
    }
}`

export const getRestaurantDetail = `query Restaurant($id:String){
      restaurant(id:$id){
      _id
      orderId
      orderPrefix
      slug
      name
      image
      address
      location{coordinates}
      deliveryTime
      minimumOrder
      tax
      shopType
      categoryType
      categories{
        _id
        title
        emoji
        image
        foods{
          _id
          title
          emoji
          description
          details
          images
          variations{
            _id
            title
            price
            discounted
            addons
            isOutOfStock
          }
          image
          isActive
          isOutOfStock
        }
      }
      options{
        _id
        title
        description
        price
      }
      addons{
        _id
        options
        title
        description
        quantityMinimum
        quantityMaximum
      }
      shopType
    }
}`

export const getOffers = `query Offers{
  offers{
    _id
    name
    tag
    restaurants{
      _id
      name
    }
  }
}`

export const getSections = `query Sections{
  sections{
    _id
    name
    enabled
    restaurants{
      _id
      name
    }
  }
}`

export const pageCount = `
query PageCount($restaurant:String!){
  pageCount(restaurant:$restaurant)
}
`
export const getUsers = `query{
    users{
      _id
      name
      email
      phone
      addresses{
        location{coordinates}
        deliveryAddress
      }
    }
  }`

export const getRiders = `query{
    riders{
      _id
      name
      username
      password
      phone
      available
      accountNumber
      bankDetails{
        accountHolderName
        bankName
        accountNumber
        sortCode
      }
      zone{
        _id
        title
      }
    }
  }`

export const getStaffs = `query staffs{
    staffs{
      _id
      name
      email
      plainPassword
      password
      phone
      isActive
      permissions
    }
  }`

export const getAvailableRiders = `query{
    availableRiders{
      _id
      name
      username
      phone
      available
      zone{
        _id
      }
    }
  }`

export const withdrawRequestQuery = `query GetWithdrawRequests($offset:Int){
      getAllWithdrawRequests(offset:$offset){
          success
          message
          data{
            _id
            requestId
            requestAmount
            requestTime
            requesterType
            requesterName
            rider{
              _id
              name
              currentWalletAmount
              accountNumber
              bankDetails{
                accountHolderName
                bankName
                accountNumber
                sortCode
              }
            }
            influencer{
              _id
              name
              currentWalletAmount
              bankDetails{
                accountHolderName
                bankName
                accountNumber
                sortCode
              }
            }
            status
          }
          pagination{
            total
          }
      }
  }`

export const getBanners = `query Banners{
    banners {
      _id
      title
      description
      action
      screen
      file
      parameters
    }
  }`
export const getBannerActions = `query BannerActions{
    bannerActions
  }`

// Version
export const getVersions = `
query GetVersions {
  getVersions {
    customerAppVersion {
        android
        ios
    }
    riderAppVersion {
        android
        ios
    }
    restaurantAppVersion {
        android
        ios
    }
  }
}
`

export const getTicketUsersWithLatest = `
query GetTicketUsersWithLatest($input: FiltersInput) {
  getTicketUsersWithLatest(input: $input) {
    users {
      _id
      name
      email
      phone
      isActive
      userType
      latestTicket {
        _id
        unreadMessage
        title
        description
        status
        category
        orderId
        otherDetails
        createdAt
        updatedAt
      }
    }
    docsCount
    totalPages
    currentPage
  }
}
`

export const getSingleUserSupportTickets = `
query GetSingleUserSupportTickets($input: SingleUserSupportTicketsInput) {
  getSingleUserSupportTickets(input: $input) {
    tickets {
      _id
      unreadMessage
      title
      description
      status
      category
      orderId
      otherDetails
      createdAt
      updatedAt
      user {
        _id
        name
        email
        phone
      }
    }
    docsCount
    totalPages
    currentPage
  }
}
`

export const getTicketMessages = `
query GetTicketMessages($input: TicketMessagesInput!) {
  getTicketMessages(input: $input) {
    messages {
      _id
      senderType
      content
      attachments
      isRead
      ticket
      createdAt
      updatedAt
    }
    ticket {
      _id
      title
      description
      status
      category
      orderId
      otherDetails
      createdAt
      updatedAt
      user {
        _id
        name
        email
        phone
      }
    }
    page
    totalPages
    docsCount
  }
}
`

export const getSingleSupportTicket = `
query GetSingleSupportTicket($ticketId: ID!) {
  getSingleSupportTicket(ticketId: $ticketId) {
    _id
    title
    description
    status
    category
    orderId
    otherDetails
    createdAt
    updatedAt
    user {
      _id
      name
      email
      phone
    }
  }
}
`

const REPORT_FIELDS = `
  invoiceNumber
  invoiceDate
  periodStart
  periodEnd
  currencySymbol
  issuer {
    companyName
    companyAddress
    companyPhone
    companyFax
    vatNumber
  }
  recipient {
    name
    address
    phone
  }
  charges {
    label
    amount
  }
  settlement {
    salesTotal
    commissionTotal
    payoutTotal
    creditFundedTotal
    borkuToSettle
  }
  platformCollected {
    commission
    delivery
    serviceFee
    tips
    otherFees
    creditApplied
    total
    chargedTotal
  }
  orders {
    orderId
    date
    type
    cash
    card
    refund
    total
  }
  cashTotal
  cardTotal
  refundTotal
  ordersTotal
  subtotal
  vatRate
  vatAmount
  totalIncVat
`

export const getStoreReport = `query StoreReport($restaurantId: String!, $startDate: String!, $endDate: String!) {
  storeReport(restaurantId: $restaurantId, startDate: $startDate, endDate: $endDate) {
    ${REPORT_FIELDS}
  }
}`

export const getRiderReport = `query RiderReport($riderId: String!, $startDate: String!, $endDate: String!) {
  riderReport(riderId: $riderId, startDate: $startDate, endDate: $endDate) {
    ${REPORT_FIELDS}
  }
}`

export const getReportSchedules = `query ReportSchedules {
  reportSchedules {
    _id
    restaurant { _id name address }
    enabled
    recipientEmail
    frequency
    dayOfMonth
    dayOfWeek
    hour
    minute
    lastSentPeriod
    lastSentAt
    lastError
  }
}`

export const getReportSendLog = `query ReportSendLog($limit: Int) {
  reportSendLog(limit: $limit) {
    _id
    restaurantName
    period
    recipient
    invoiceNumber
    status
    error
    trigger
    createdAt
  }
}`

export const getRefundOrder = `query RefundOrder($orderId: String!) {
  refundOrder(orderId: $orderId) {
    _id
    orderId
    restaurantName
    orderStatus
    paymentMethod
    orderAmount
    refundedAmount
    orderDate
    refunds { _id amount reason createdBy createdAt }
  }
}`

export const getPartialRefunds = `query PartialRefunds($startDate: String, $endDate: String) {
  partialRefunds(startDate: $startDate, endDate: $endDate) {
    _id
    orderId
    restaurantName
    orderStatus
    paymentMethod
    orderAmount
    refundedAmount
    orderDate
    refunds { _id amount reason createdBy createdAt }
  }
}`

export const getCompanyConfiguration = `query Configuration {
  configuration {
    _id
    companyName
    companyAddress
    companyPhone
    companyFax
    vatNumber
    currencySymbol
  }
}`

// Pickers only need identity, so these avoid the heavy `restaurants` query,
// whose transform runs a geospatial zone lookup per restaurant.
export const getRestaurantOptions = `query RestaurantOptions {
  restaurantOptions {
    _id
    name
    address
  }
}`

export const getRiderOptions = `query RiderOptions {
  riderOptions {
    _id
    name
  }
}`

export const getInfluencers = `query Influencers{
    influencers{
      _id
      name
      email
      password
      phone
      image
      ratePerOrder
      ordersCount
      totalEarnings
      enabled
      bankDetails{
        accountHolderName
        bankName
        accountNumber
        sortCode
      }
      coupons{
        _id
        title
        discount
        discountType
      }
    }
  }`

export const getInfluencerDashboard = `query InfluencerDashboard($influencerId:String,$startDate:String,$endDate:String){
    influencerDashboard(influencerId:$influencerId,startDate:$startDate,endDate:$endDate){
      ratePerOrder
      usersUsed
      ordersCount
      activeOrdersCount
      pickupOrders
      deliveryOrders
      totalEarnings
      currentWalletAmount
      withdrawnWalletAmount
      periodStart
      periodEnd
      periodEarnings
      periodOrdersCount
      influencer{
        _id
        name
        email
        phone
        enabled
        bankDetails{
          accountHolderName
          bankName
          accountNumber
          sortCode
        }
      }
      coupons{
        _id
        title
        discount
        discountType
        enabled
        usersUsed
        ordersCount
      }
    }
  }`

export const getInfluencerOrders = `query InfluencerOrders($offset:Int,$limit:Int,$search:String,$influencerId:String){
    influencerOrders(offset:$offset,limit:$limit,search:$search,influencerId:$influencerId){
      totalCount
      orders{
        _id
        orderId
        couponTitle
        earning
        isEarning
        createdAt
      }
    }
  }`

export const getInfluencerWithdrawRequests = `query InfluencerWithdrawRequests($offset:Int,$influencerId:String){
    influencerWithdrawRequests(offset:$offset,influencerId:$influencerId){
      _id
      requestId
      requestAmount
      requestTime
      status
    }
  }`

// Slim projections used by the notification feed. They mirror the order
// queries above but only pull the fields the bell needs, so polling them in
// the background stays cheap.
export const getActiveOrdersForNotifications = `query GetActiveOrders($restaurantId:ID){
    getActiveOrders(restaurantId:$restaurantId){
      _id
      orderId
      orderStatus
      isPickedUp
      deliveryMode
      courierStatus
      createdAt
      updatedAt
      acceptedAt
      assignedAt
      pickedAt
      deliveredAt
      cancelledAt
      restaurant{
        _id
        name
      }
      rider{
        _id
        name
      }
    }
  }`

export const getRecentOrdersForNotifications = `query AllOrdersPaginated($page: Int, $rows: Int) {
    allOrdersPaginated(page: $page, rows: $rows) {
      orders {
        _id
        orderId
        orderStatus
        isPickedUp
        createdAt
        updatedAt
        acceptedAt
        assignedAt
        pickedAt
        deliveredAt
        cancelledAt
        restaurant {
          _id
          name
        }
        rider {
          _id
          name
        }
      }
    }
  }`

export const getRecentRestaurantOrdersForNotifications = `query ordersByRestId($restaurant:String!,$page:Int,$rows:Int){
    ordersByRestId(restaurant:$restaurant,page:$page,rows:$rows){
      _id
      orderId
      orderStatus
      createdAt
      updatedAt
      acceptedAt
      assignedAt
      pickedAt
      deliveredAt
      cancelledAt
      restaurant{
        _id
        name
      }
      rider{
        _id
        name
      }
    }
  }`

const dashboardPeriodFields = `
      totalOrders
      successfulOrders
      cancelledOrders
      inProgressOrders
      earnings
      grossSales
      averageOrderValue
      tips
      itemsSold
      completionRate
      uniqueCustomers
      newCustomers
      returningCustomers
      repeatCustomers
      pickupOrders
      deliveryOrders
      avgAcceptMinutes
      avgPrepMinutes`

// Shared with the store app's dashboard (same resolver, same figures)
export const restaurantDashboard = `query RestaurantDashboard($restaurant: String, $startDate: String!, $endDate: String!, $previousStartDate: String, $timezoneOffset: Int) {
  restaurantDashboard(restaurant: $restaurant, startDate: $startDate, endDate: $endDate, previousStartDate: $previousStartDate, timezoneOffset: $timezoneOffset) {
    current {${dashboardPeriodFields}
    }
    previous {${dashboardPeriodFields}
    }
    daily {
      date
      successful
      cancelled
      earnings
    }
    hourly
    topItems {
      title
      image
      quantity
      earnings
    }
    rating
    reviewCount
  }
}`

export const getCustomerMarketing = `query CustomerMarketing($days: Int, $startDate: String, $endDate: String) {
  customerMarketing(days: $days, startDate: $startDate, endDate: $endDate) {
    summary {
      windowDays
      totalCustomers
      newCustomers
      orderedInWindow
      neverOrdered
      activeCustomers
      inactive30
      inactive60
      dormant90
      firstTimeOrderers
      incompleteRegistration
      repeatCustomers
      totalRevenue
      orders7
      orders14
      orders30
    }
    topStores {
      _id
      name
      orders
      sales
    }
    topProducts {
      _id
      title
      store
      quantity
      sales
    }
    customers {
      _id
      name
      email
      phone
      phoneIsVerified
      emailIsVerified
      hasPhone
      joinedAt
      isNew
      totalOrders
      ordersInWindow
      spentInWindow
      totalSpent
      averageOrderValue
      couponOrders
      firstOrderAt
      lastOrderAt
      isFirstTimeInWindow
      segment
      address
      addressDetails
      addressSource
      postcodeArea
      latitude
      longitude
      zone
      favouriteStore
      referred
      credits
      offerNotifications
    }
  }
}`
